import Image from 'next/image'
import { Fragment } from 'react'

import { ImageWithPlaceholder } from '@components/ImageWithPlaceholder'
import { WhySection } from '@components/sections/WhySection'
import { useIsLaptop } from '@hooks/use-media-query'
import Hexagon from '@public/images/skills-hexagon.svg'
import { Roster } from '@ui/article/Roster'

import {
  BoxWrapper,
  ListTitle,
  Subtitle,
  Title,
  Wrapper,
  WrapperImage,
  HexagonWrapper,
  Content,
} from './styles'

export function CaseSection({
  imageDetails,
  title,
  subtitle,
  table,
  list,
  svgHexagon,
  svgHexagonLocation = 48,
  hexagonMarker,
  typeOfMarker,
  listWidth,
  marginTop = '128px',
  subtitleMargin = '32px',
  titleMargin = '32px',
  titlePosition = 'flex-start',
}) {
  const isLaptop = useIsLaptop()

  return (
    <BoxWrapper>
      <Content>
        <Wrapper marginTop={marginTop}>
          <Title titlePosition={titlePosition} as="h2">
            {title}
          </Title>
          {subtitle && (
            <Subtitle subtitleMargin={subtitleMargin}>{subtitle}</Subtitle>
          )}
          {table && <WhySection config={table} tableSubtitleWidth="420px" />}
          {list &&
            list.map(({ id, title: listTitle, value }) => (
              <Fragment key={`${listTitle}_${id}`}>
                {listTitle && (
                  <ListTitle as="h3" subtitleMargin={titleMargin}>
                    {listTitle}
                  </ListTitle>
                )}
                <Roster
                  maxWidth={listWidth}
                  hexagonMarker={hexagonMarker}
                  typeOfMarker={typeOfMarker}
                  config={value}
                />
              </Fragment>
            ))}
        </Wrapper>
      </Content>
      {svgHexagon && (
        <HexagonWrapper location={svgHexagonLocation}>
          <Hexagon />
        </HexagonWrapper>
      )}
      {imageDetails &&
        imageDetails?.map(
          ({
            id,
            imagePath,
            alt,
            imageTitle,
            width,
            height,
            position = 'absolute',
            rightPosition,
            leftPosition,
            bottomPosition,
            topPosition,
            show = true,
            imagePathLaptop = imagePath,
            order = '1',
            mobilePosition = 'relative',
            className,
            quality,
          }) => (
            <WrapperImage
              className={className}
              key={id}
              position={position}
              mobilePosition={mobilePosition}
              top={topPosition}
              right={rightPosition}
              left={leftPosition}
              bottom={bottomPosition}
              show={show}
              order={order}
            >
              {id && id.includes('hexagon') ? (
                <Image
                  src={isLaptop ? imagePathLaptop : imagePath}
                  alt={alt}
                  width={width}
                  height={height}
                  title={imageTitle}
                  quality={quality}
                />
              ) : (
                <ImageWithPlaceholder
                  src={isLaptop ? imagePathLaptop : imagePath}
                  alt={alt}
                  width={width}
                  height={height}
                  title={imageTitle}
                  quality={quality}
                />
              )}
            </WrapperImage>
          )
        )}
    </BoxWrapper>
  )
}
